import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export interface IconProps {
    size?: number;
    color?: string;
    disable?: boolean;
    hoverColor?: string;
    strokeColor?: string;
    strokeWidth?: number;
    rotate?: number;
    border?: string;
    borderRadius?: string;
    backgroundColor?: string;
    className?: string;
    onClick?: () => void;
    children: ReactNode;
    'data-test'?: string;
    'data-test-id'?: string;
}

const IconWrapper = styled.span<IconProps>`
    display: inline-block;
    ${({ rotate }) =>
        rotate !== undefined &&
        css`
            transform: rotate(${rotate}deg);
        `}
    ${({ border }) =>
        border &&
        css`
            border: ${border};
        `}
  ${({ borderRadius }) =>
        borderRadius &&
        css`
            border-radius: ${borderRadius};
        `}
  ${({ backgroundColor }) =>
        backgroundColor &&
        css`
            background-color: ${backgroundColor};
        `}
  svg {
        width: ${({ size }) => (size ? `${size}px` : '16px')};
        height: ${({ size }) => (size ? `${size}px` : '16px')};
        path {
            fill: ${({ color, disable }) => (disable ? '#D9D9D9' : color)};
        }
        &:hover {
            path {
                fill: ${({ hoverColor, color }) => hoverColor || color};
            }
        }
        path {
            stroke: ${({ strokeColor }) => strokeColor};
            strokewidth: ${({ strokeWidth }) => strokeWidth};
        }
    }
`;

const Icon: React.FC<IconProps> = (props) => {
    const {
        size,
        color,
        disable,
        hoverColor,
        rotate,
        border,
        borderRadius,
        backgroundColor,
        className,
        onClick,
        children,
    } = props;
    return (
        <IconWrapper
            size={size}
            color={color}
            disable={disable}
            hoverColor={hoverColor}
            rotate={rotate}
            border={border}
            borderRadius={borderRadius}
            backgroundColor={backgroundColor}
            className={`align-middle ${className}`}
            onClick={onClick}
            data-test={props['data-test']}
            data-test-id={props['data-test-id']}
            data-asper-icon
        >
            {children}
        </IconWrapper>
    );
};

export default Icon;
